export { default } from './Name';
